import React from "react";

const DealsDisclaimer = () => {
  return (
    <div className="text-xs">
      <div className="font-extrabold mb-xs">Disclaimer</div>
      <div className="mb-xl">
        Deals: While supplies last. Not valid for cash or cash equivalent.
        Participating Dispensary owns all choices related to the deal & content
        as well as its administration. 21+ or qualified patients only.
      </div>
      <div>
        Leafly Pickup Promotion: Subject to participating retailers' product
        availability, promotion is for Leafly Pickup Reservations only and can
        not be combined with other dispensary promotions. Not valid for cash or
        cash equivalent. Participating retailers own all choices related to the
        deal, content, and its administration. Promotion may be extended,
        modified, or discontinued at any time without notice. Leafly operates in
        compliance with all applicable laws regarding access to cannabis. You
        must be 21+ or a registered patient for eligibility. Enjoy Responsibly.
      </div>
    </div>
  );
};

export default DealsDisclaimer;
